module.exports = "<div id=\"map\"></div>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/mappointer/mappointer.html
// module id = ../../../../../app/shared/components/mappointer/mappointer.html
// module chunks = main